module.exports = "https://static.cdns.space/classicbook-temp-tx/img/1-3.7f9bb13c.jpg";